/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfProblem } from '../models/data-page-of-problem';
import { problemList } from '../fn/problem/problem-list';
import { ProblemList$Params } from '../fn/problem/problem-list';

@Injectable({ providedIn: 'root' })
export class ProblemService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `problemList()` */
  static readonly ProblemListPath = '/problem/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `problemList()` instead.
   *
   * This method doesn't expect any request body.
   */
  problemList$Response(params?: ProblemList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfProblem>> {
    return problemList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `problemList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  problemList(params?: ProblemList$Params, context?: HttpContext): Observable<DataPageOfProblem> {
    return this.problemList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfProblem>): DataPageOfProblem => r.body)
    );
  }

}
